import { JourneyMapDraft } from '../../types/journeyMap';

const getItemPositionX = (item: any) =>
  Number(item?.position_x ?? item?.metadata?.position_x ?? 0);

const getItemPositionY = (item: any) =>
  Number(item?.position_y ?? item?.metadata?.position_y ?? 0);

export const getNextItemOrder = (draft: JourneyMapDraft) =>
  draft.items.filter((i) => !i.isDeleted).length + 1;

export const recalculateOrdersFromLayout = (draft: JourneyMapDraft) => {
  const activeItems = draft.items.filter((i) => !i.isDeleted);

  const sorted = [...activeItems].sort((a, b) => {
    const ax = getItemPositionX(a);
    const bx = getItemPositionX(b);

    if (Math.abs(ax - bx) > 40) {
      return ax - bx;
    }

    const ay = getItemPositionY(a);
    const by = getItemPositionY(b);

    return ay - by;
  });

  sorted.forEach((item, index) => {
    item.order = index + 1;
  });
};

export const getNextIncrementedName = (
  draft: JourneyMapDraft,
  baseName: string,
) => {
  const activeItems = draft.items.filter((i) => !i.isDeleted);
  const normalizedBase = baseName.trim().toLowerCase();

  const usedNumbers = activeItems
    .map((item) => item.name?.trim() || '')
    .filter(Boolean)
    .map((name) => {
      const lower = name.toLowerCase();
      if (lower === normalizedBase) return 1;

      const prefix = `${normalizedBase} `;
      if (!lower.startsWith(prefix)) return null;

      const suffix = lower.slice(prefix.length).trim();
      const parsed = Number(suffix);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
    })
    .filter((n): n is number => n !== null);

  let next = 1;
  while (usedNumbers.includes(next)) {
    next += 1;
  }

  return `${baseName} ${next}`;
};